// Import utilities
import { getDOMElements } from '@builder/common/utilities';

// Load class that creates the grid with integrations
import ItemCreatorIntegrations from '@builder/item/integrations-grid';

/**
 * Adds the initial "Add action" button (when there aren't actions)
 */
export default class ItemInitialAction {
	/**
	 * Renders the item
	 * 
	 * @return {undefined}
	 */
	constructor() {
		// Create template
		const $template = document.createElement( 'div' );
		$template.classList.add( 'uap-item', 'uap-item--actions-initial' );

		// Add content
		$template.insertAdjacentHTML( 'beforeEnd', `
			<div class="uap-item-inner">
				<div class="uap-item-sidebar">
					<div class="uap-item-icon"></div>
				</div>
				<div class="uap-item-main">
					<uo-button
						color="secondary"
						size="small"
						class="uap-item-main-initial-action-button uap-spacing-right uap-spacing-right--xsmall"
					>
						${ UncannyAutomator.i18n.action.add }
					</uo-button>

					<ua-builder-conditions-add-button
						size="small"
					>
						${ UncannyAutomator.i18n.conditions.addFilter }
					</ua-builder-conditions-add-button>
				</div>
			</div>
		` );

		// Add to the metabox
		const $metabox = getDOMElements( 'metabox', {
			type: 'action',
		} ).get(0);

		$metabox.appendChild( $template );

		// Add event listener to the button
		$template.querySelector( '.uap-item-main-initial-action-button' ).addEventListener( 'click', () => {
			// Show the integrations grid
			new ItemCreatorIntegrations( 'action' );
		} );
	}
}
